<svg width="25" height="25" fill="none" version="1.1" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
 <g clip-path="url(#a)">
  <path d="m12.5 5.4247c-5 0-9.27 3.11-11 7.5 1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="#000"/>
 </g>
 <defs>
  <clipPath id="a">
   <rect transform="translate(.5 .92468)" width="24" height="24" fill="#fff"/>
  </clipPath>
 </defs>
</svg>
